//Has a dependency of https://github.com/typekit/webfontloader
//TODO handle passing in the font's css file
function FontLoader(assetData) {
    dpd.Loader.call(this, assetData);
    this.fontsToLoad = assetData.fontFamilys;
    this.urls = assetData.urls;
}
FontLoader.prototype = Object.create(dpd.Loader.prototype);

Object.assign(FontLoader.prototype, {
    constructor: FontLoader,

    loadExecutor: function(resolve, reject) {

        this.resolve = resolve;
        this.reject = reject;

        var webFontConfig = {
            active: this.loadHandler.bind(this),
            inactive: this.errorHandler.bind(this),
            custom: {
                families: this.fontsToLoad,
                urls: this.urls
            }
        };

        WebFont.load(webFontConfig);
    },

    loadHandler: function() {
        this.asset = this.fontsToLoad;
        this.resolve(this);
    },

    errorHandler: function() {
        //this.reject(new Error("failed to load font" + this.url));
        //For snow globe this is not a critical resource
        //so continue on
        this.asset = this.fontsToLoad;
        this.resolve(this);
    }
});